import ACTIONS from "../constants/actions";

const {
  GET_FACE_USER_BY_ID,
  GET_FACE_USER_BY_ID_SUCCESS,
  GET_FACE_USER_BY_ID_FAIL,
  UPLOAD_USER_FACE,
  UPLOAD_USER_FACE_SUCCESS,
  UPLOAD_USER_FACE_FAIL,
  SHOW_CROP_MODAL,
  HIDE_CROP_MODAL,
  DELETE_USER_FACE,
  DELETE_USER_FACE_SUCCESS,
  DELETE_USER_FACE_FAIL,
} = ACTIONS;

const initialState = {
  isLoadingFaces: false,
  isUploadFile: false,
  fileList: [],
};

const userFaceReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FACE_USER_BY_ID:
      return {
        ...state,
        isLoadingFaces: true,
      };
    case GET_FACE_USER_BY_ID_SUCCESS:
      return {
        ...state,
        isLoadingFaces: false,
        fileList: action.payload,
      };
    case GET_FACE_USER_BY_ID_FAIL:
      return {
        isLoadingFaces: false,
        ...state,
      };
    case UPLOAD_USER_FACE:
      return {
        ...state,
        isUploadFile: true,
      };
    case UPLOAD_USER_FACE_SUCCESS:
      //Add new File to List
      state.fileList.push(action.payload);
      return {
        ...state,
        isUploadFile: false,
        isShowCrop: false,
      };
    case UPLOAD_USER_FACE_FAIL:
      return {
        ...state,
        isUploadFile: false,
        isShowCrop: false,
      };
    case SHOW_CROP_MODAL:
      return {
        ...state,
        isShowCrop: true,
      };
    case HIDE_CROP_MODAL:
      return {
        ...state,
        isShowCrop: false,
      };
    case DELETE_USER_FACE:
      return {
        ...state,
        isLoadingFaces: true,
      };
    case DELETE_USER_FACE_SUCCESS:
      const newFileList = state.fileList.filter(
        (item) => item.uid !== action.payload
      );
      return {
        ...state,
        fileList: newFileList,
        isLoadingFaces: false,
      };
    case DELETE_USER_FACE_FAIL:
      return {
        ...state,
        isLoadingFaces: false,
      };
    default:
      return state;
  }
};
export default userFaceReducer;
